<template>
  <div>
    <Popup v-if="openPop" v-on:close="openPop=false">
      <div slot="table">
        <h3 class="py-4">{{recognizeData.title}}簡介</h3>
        <div style="overflow:auto; height:55vh"  id="style-1">
          <table class="table table-borderless">
            <thead>
              <tr>
                <th>{{$t('learning_contents')}}</th>
                <th>{{$t('last_update_time')}}</th>
                <th>{{$t('play')}}</th>
                <th>{{$t('download')}}</th>
              </tr>
            </thead>
            <tbody style="border-top:1px #cccccc solid;text-align: left; " >
              <tr v-for="(item, index) in recognizeData.data" :key="index">
                <td style="width:40%">
                  {{item.sentence}}
                </td>
                <td>
                  {{item.createTime?item.createTime:'----/--/-- 00:00:00'}}
                </td>
                <td>
                  <p class="link-tag pointer" v-if="item.voiceUrl" @click="playAudio(item.voiceUrl)">
                    {{$t('play')}}
                  </p>
                  <p v-else>{{$t('play')}}</p>
                </td>
                <td>
                  <a v-if="item.voiceUrl" style="color:blue" download target="_blank" :href="item.voiceUrl">
                    {{$t('download')}}
                  </a>
                  <p v-else>{{$t('download')}}</p>
                </td>
              </tr>
            </tbody>
          </table>
          <audio id="audio">
            <source :src="voiceUrl" type="audio/ogg">
          </audio>
        </div>
      </div>
    </Popup>
    <div class="tag">
      <div class="d-flex align-items-center justify-content-between">
        <div class="ml-5">
          <h4>{{targetInfo.username}} | {{targetInfo.realname}} </h4>
        </div>
        <div class="d-flex">
          <div v-if="userInfo.rolename === 'Teacher'" class="m-auto type-selecter">
            <select v-model="lessonId" class="scene-select">
              <option v-for="item in LessonList" :value="item.id" :key="item.id">{{item.localName}}</option>
            </select>
          </div>
          <img class="back-icon pointer my-4" @click="previousPage" style="height:20px" src="../../../../assets/image/icon/close_lesson.png" />
        </div>
      </div>
    </div>
    <div class="px-5 table-responsive" style="overflow: auto; font-size:1.25rem">
      <table class="table table-borderless table-hover ">
          <thead>
            <tr>
              <th>{{$t('course_name')}}</th>
              <th>{{$t('unit_theme')}}</th>
              <th>{{$t('study_time')}}</th>
              <th>{{$t('views')}}</th>
              <th v-if="mode==='App'">{{$t('oral_practice')}}</th>
            </tr>
          </thead>
          <tbody style="border-top:1px #cccccc solid;text-align: left;">
            <tr v-for="(item , index) in record" :key="index">
              <td>
                {{item.lessonName}}
              </td>
              <td>
                {{item.packageName}}
              </td>
              <td>
                {{item.spendTime?item.spendTime:'00:00:00'}}
              </td>
              <td >
                {{item.learnCount}}
              </td>
              <td v-if="mode==='App'" >
                <a v-if="item.hasRecognize" href="javascript:void(0);" @click="openRecognize(item.id, item.packageName)">
                  {{$t('view')}}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination v-if="pageCount>1" class="mt-5" :current="pageIndex" :total="pageCount" v-on:page="updatePage" />
      </div>
  </div>
</template>

<script>
import Popup from './Popup'
import Pagination from '../../../../components/Pagination'
import api from '../../../../store/api'
export default {

  name: 'AR-Record',

  data () {
    return {
      openPop: false,
      LessonList: [
        {
          localName: 'All',
          id: 0
        }
      ],
      recognizeData: {
        title: '',
        data: []
      },
      targetInfo: {},
      lessonId: this.$route.params.lesson,
      record: [],
      pageIndex: 1,
      pageCount: 0,
      voiceUrl: ''
    }
  },
  components: {
    Popup,
    Pagination
  },
  computed: {
    memberId () {
      return this.$route.params.id
    },
    countryId () {
      return this.$route.params.country
    },
    userInfo () {
      return this.$store.state.auth.user
    },
    mode () {
      return this.$route.params.mode
    },
    lesson () {
      return this.$route.params.lesson
    }
  },
  watch: {
    lessonId (value) {
      this.pageIndex = 1
      this.getRecordList()
    },
    voiceUrl (val) {
      this.playAudio(val)
    }
  },
  async mounted () {
    await this.getMember()
    await this.getLessonList()
    await this.getRecordList()
  },
  methods: {
    previousPage () {
      this.$router.go(-1)
    },
    async getLessonList () {
      let params = {
        pageSize: 25
      }
      const { data } = await api.get(`Globetrotting/Country/${this.countryId}/Lesson`, {params})
      this.LessonList.push(...data.data)
    },
    async getRecordList () {
      const { data } = await api.get(`Globetrotting/Record/${this.mode}/Country/${this.countryId}/Lessons`, {
        params: {
          userId: this.memberId,
          packageId: this.lessonId !== '' ? this.lessonId : this.lesson,
          pageIndex: this.pageIndex,
          pageSize: 10
        }
      })
      this.record = data.data
      this.pageIndex = data.pageIndex
      this.pageCount = data.pageCount
    },
    updatePage (page) {
      this.pageIndex = page
      this.getRecordList()
    },
    async getRecognize (id) {
      let params = {
        lessonId: id,
        userId: this.memberId
      }
      const { data } = await api.get(`Globetrotting/Record/App/Recognize`, { params })
      this.recognizeData.data = data.data
    },
    openRecognize (id, title) {
      this.openPop = true
      this.recognizeData.title = title
      this.getRecognize(id)
    },
    async getMember () {
      const { data } = await api.get(`/Globetrotting/Record/web/Summary?userId=${this.memberId}`)
      console.log(data.data[0].realName)
      this.targetInfo.username = data.data[0].userName
      this.targetInfo.realname = data.data[0].realName
    },
    async playAudio (url) {
      this.voiceUrl = url
      let dom = document.getElementById('audio')
      dom.load()
      const playPromise = dom.play()
      if (playPromise !== undefined) {
        try {
          await playPromise
        } catch (error) {
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/style/color.scss";
  .list-box {
    width: 60%;
    margin: auto;
  }
  .menu-box {
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    border-radius: 10px;
    border: 1.5px solid #6666;
    margin: 10px auto;
    padding: 10px 20px;
    p {
      margin: 0;
    }
      &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
  .progress {
    color: blue;
  }

  .tag {
    text-align: left;
    border-bottom: #bbbbbb solid 2px;
  }

  .back-icon {
    margin-right: 40px;
    margin-left: 40px;
    cursor: pointer;
  }
  .scene-select {
    margin: auto 5px !important;
  }
  @media only screen and (max-width: 768px) {
    .type-selecter {
      position: absolute;
      left: 20%;
    }
  }
  #style-1::-webkit-scrollbar-track {
    border-radius: 20px;
    // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: rgb(206, 205, 205);
  }
  #style-1::-webkit-scrollbar {
    width: 5px;
    background-color: #F5F5F5;
  }
  #style-1::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: #2c3e50;
  }
  .link-tag {
    color: blue;
    &:hover {
      text-decoration: underline;
    }
  }
</style>


// WEBPACK FOOTER //
// Record.vue?6653fc4f